export const invitaciones2026 = [
  {
    titulo: "CAASIM-HGO-INV3-OP-01-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-02-2026",
  },
  {
    titulo: "CAASIM-HGO-INV3-OP-03-2026",
  },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-04-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-05-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-06-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-07-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-08-2025",
  // },
  // {
  //   titulo: "ITP-CAASIM-SRMYSG-SAL-01/2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-09-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-10-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-11-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-12-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-13-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-14-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-15-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-16-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-17-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-18-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-19-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-20-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-21-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-22-2025",
  // },
  // {
  //   titulo: "CAASIM-HGO-INV3-OP-23-2025",
  // },
  // {
  //   titulo: "ITP-CAASIM-SRMYSG-SAL-02/2025",
  // },
];
